import React, { useEffect ,useState} from 'react'
import "./style.css";
import JobCard from './JobCard';
import { FilterBox, MobileFilterModal } from "../../Components/Filter"
import Pagination from 'react-js-pagination';
import Base from '../../Components/Layout/Base';
import { useSelector, useDispatch } from 'react-redux';
import { fetchJob } from '../../Redux/Actions/jobBoard';
import { ACTIVE_PAGE, SET_LOCAL_FILTER } from '../../Redux/Actions/types';
import { useNavigate } from 'react-router-dom';
import filter from "../../Assets/images/filter.svg"
import nojob from "../../Assets/images/noJobs.png"
import { fetchNormalSubmission, getProfile, introVideoDetails } from '../../Redux/Actions/ProfileSteps';
const JobBoard = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const jobs = useSelector(s => s.jobBoard.jobs);
  const internJobs = useSelector(s => s.jobBoard.internJobs);
  const activePage = useSelector(s => s.jobBoard.activePage);
  const localFilter = useSelector(s => s.jobBoard.localFilter);
  const [filterModal, setFilterModal] = useState(false);
    const kids = useSelector(state => state.dashboard.kids);
  const resumeData = useSelector(s => s.ProfileSteps.submissionData);
  const data = useSelector(s => s.ProfileSteps.introData);
  const profileData = useSelector(s => s.ProfileSteps.profileData);

  const [activeTab, setActiveTab] = React.useState("fulltime");
  useEffect(()=>{
    kids && kids[0]?.id && dispatch(getProfile(kids[0]?.id))
    kids && kids[0]?.id && dispatch(fetchNormalSubmission({ kid_id: kids[0]?.id,"activity_id":1172 }))
    kids && kids[0]?.id && dispatch(introVideoDetails({ kid_id: kids[0]?.id }))
  },[kids])
  useEffect(() => {
    dispatch(fetchJob({ pageNo: 0, pageSize: 5 },"fulltime", {
      job_types: [ "FULLTIME"],
      // job_locations: ["New Delhi. New Delhi. India","Gurugram. Haryana. India","Noida. Uttar Pradesh. India"],
      // pay_scale: {"minimum":0.0,"maximum":50.0},
      // company_list:[{"object_id": "1470", "object_name": "AGRIM"}, {"object_id": "609", "object_name":"KidEx"}, {"object_id": "3503", "object_name":"AdmitKard"}],
      // application_status_list:["APPLICATION_SENT", "SHORTLISTED", "IN_PROCESS", "SELECTED", "WITHDRAWN", "REJECTED"]
    }))
  }, [])
  // useEffect(() => {
  //   handleResetFilter()
  // }, [])
  const handleFilterChange = obj => {
    const payload = { ...localFilter }
    // dispatch(setLocalFilter({ ...payload, ...obj }))
    dispatch({
      type: SET_LOCAL_FILTER,
      payload: { ...payload, ...obj }
    });
  }
  const handleResetFilter = obj => {
    dispatch({
      type: SET_LOCAL_FILTER,
      payload: {}
    });
    dispatch(fetchJob(
  { pageNo: 0, pageSize: 5 },
  activeTab, 
  activeTab === "fulltime" ? { job_types: ["FULLTIME"] } : {}
))

  }
  const applyFilter = () => {
    dispatch(fetchJob({ pageNo: 0, pageSize: 5 },activeTab, {...localFilter}))
  }
  const setThePage = page => {
    dispatch({
      type: ACTIVE_PAGE,
      payload: page
    });
  }
  const handleInternships = () => {
    const payload = { ...localFilter }
    setActiveTab("internships");
    
    dispatch({
      type: SET_LOCAL_FILTER,
      payload: {job_types: ["INTERNSHIPTWOMONTHS", "INTERNSHIPSIXMONTHS"] }
    });
    dispatch(fetchJob({ pageNo: 0, pageSize: 5 },"internships", {
      job_types: ["INTERNSHIPTWOMONTHS", "INTERNSHIPSIXMONTHS"],
    }))
  }
  const handleFullTime = () => {
    const payload = { ...localFilter }
    setActiveTab("fulltime");
    dispatch({
      type: SET_LOCAL_FILTER,
      payload: {job_types: ["FULLTIME"] }
    });
    dispatch(fetchJob({ pageNo: 0, pageSize: 5 },"fulltime", {
      job_types: ["FULLTIME"],
    }))
  }
  const handlePageChange = (pageNumber) => {
    const page = pageNumber - 1;
    setThePage(page);
    // dispatch(fetchJob({ pageNo: page, pageSize: 5 },activeTab, {...localFilter, activeTab == "fulltime" ? { job_types: ["FULLTIME"] } : { job_types: ["INTERNSHIPTWOMONTHS", "INTERNSHIPSIXMONTHS"]}}))
    dispatch(fetchJob(
  { pageNo: page, pageSize: 5 },
  activeTab,
  {
    ...localFilter,
    job_types: activeTab === "fulltime" 
      ? ["FULLTIME"] 
      : ["INTERNSHIPTWOMONTHS", "INTERNSHIPSIXMONTHS"]
  }
))

  };
  return (
    <Base>
      <div className='container-fluid section-bottom-padding'>
        <div className='d-flex justify-content-between align-items-center pt-5 py-4'>
            <ul className="nav nav-tabs cstm-tabs my-0" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button 
                  className="nav-link active" 
                  id="fulltime-tab" 
                  data-bs-toggle="tab" 
                  data-bs-target="#fulltime" 
                  type="button" 
                  role="tab" 
                  aria-selected="true"
                  onClick={handleFullTime}
                >
                  Full Time
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button 
                  className="nav-link" 
                  id="internships-tab" 
                  data-bs-toggle="tab" 
                  data-bs-target="#internships" 
                  type="button" 
                  role="tab" 
                  aria-selected="false"
                  onClick={handleInternships}
                >
                  Internships
                </button>
              </li>
            </ul>
            <div className="text-end d-flex d-lg-none filter-icon-img" type="button" onClick={() => setFilterModal(true)}>
                <img src={filter} alt="Filter" className='me-2'/>
                Filters
            </div>
        </div>
        <div className="tab-content" id="myTabContent">
                
          <div className="tab-pane fade show active" id="fulltime" role="tabpanel" aria-labelledby="fulltime-tab">
            <div className="row">
               <div className='d-lg-none'>
                <MobileFilterModal onShow={filterModal} onClose={() => setFilterModal(false)} handleFilterChange={handleFilterChange} type={activeTab} applyFilter={applyFilter} handleFilterReset={handleResetFilter} />
              </div>
              <div className='col-lg-3 d-none d-lg-block'>
                <div className='fiter-bg'>
                  <FilterBox handleFilterChange={handleFilterChange} applyFilter={applyFilter} handleResetFilter={handleResetFilter} type="fulltime" />
                </div>
              </div>

             <div className="col-lg-9">
  <div className="row">
    {jobs?.data?.length > 0 ? (
      jobs.data.map((item) => (
        <div className="col-lg-4 mb-4" key={item.id}>
          <JobCard 
            item={item} 
            onCardClick={() => navigate("/job-detail", { state: { data: item }})}
          />
        </div>
      ))
    ) : (
      <div className='d-flex flex-column justify-content-center align-items-center'>
        <img src={nojob} alt='No data' className='w-25 justify-content-center align-items-center d-flex mb-3' />
        <h3>No jobs Matching your filter criteria!</h3>
        <p>We are working on adding more opportunities , kindly check back later.</p></div>
    )}
  </div>

  {jobs?.data?.length > 0 && (
    <div className="pagination-container justify-content-center d-flex">
      <Pagination
        activePage={activePage + 1}
        itemsCountPerPage={5}
        totalItemsCount={jobs?.pagination_info?.total_elements}
        pageRangeDisplayed={5}
        linkClass="custm_pagination"
        onChange={handlePageChange}
        itemClassFirst="page_first"
        itemClassPrev="page_prev"
        itemClassNext="page_next"
        itemClassLast="page_last"
      />
    </div>
  )}
</div>

            </div>
          </div>

          <div className="tab-pane fade" id="internships" role="tabpanel" aria-labelledby="internships-tab">
            <div className="row">
              <div className='col-lg-3 d-none d-lg-block'>
                <div className='fiter-bg'>
                  <FilterBox handleFilterChange={handleFilterChange} applyFilter={applyFilter} handleResetFilter={handleResetFilter} type="internship" />
                </div>
              </div>

              <div className="col-lg-9">
  <div className="row">
    {internJobs?.data?.length > 0 ? (
      internJobs.data.map((item) => (
        <div className="col-lg-4 mb-4" onClick={() => navigate("/job-detail", { state: { data: item}})} key={item.id}>
          <JobCard item={item} />
        </div>
      ))
    ) : (
      <div className='d-flex flex-column justify-content-center align-items-center'>
        <img src={nojob} alt='No data' className='w-25 justify-content-center align-items-center d-flex mb-3' />
        <h3>No jobs Matching your filter criteria!</h3>
        <p>We are working on adding more opportunities , kindly check back later.</p></div>
    )}
  </div>

  {internJobs?.data?.length > 0 && (
    <div className="pagination-container justify-content-center d-flex mb-4">
      <Pagination
        activePage={activePage + 1}
        itemsCountPerPage={5}
        totalItemsCount={internJobs?.pagination_info?.total_elements}
        pageRangeDisplayed={5}
        linkClass="custm_pagination"
        onChange={handlePageChange}
        itemClassFirst="page_first"
        itemClassPrev="page_prev"
        itemClassNext="page_next"
        itemClassLast="page_last"
      />
    </div>
  )}
</div>

            </div>
          </div>
        </div>
      </div>
    </Base>
  )
}

export default JobBoard
